import { Link } from "react-router-dom";
import { NAV } from "../data";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-ink text-cream grain overflow-hidden">
    <div className="max-w-container mx-auto px-6 md:px-12 lg:px-20 pt-24 pb-10 relative">
      <div className="grid lg:grid-cols-12 gap-12 mb-16">
        <div className="lg:col-span-6">
          <p className="eyebrow mb-4">Planning & Project Controls</p>
          <p className="font-sans text-cream/60 max-w-md leading-relaxed">
            PROSPEC provides outsourced project planning and project-controls services to
            contractors — baseline programmes, progress tracking, delay analysis and defensible
            management reporting, delivered as a monthly retainer.
          </p>
        </div>
        <div className="lg:col-span-3">
          <p className="eyebrow mb-5">Navigate</p>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link
                  to={n.to}
                  data-testid={`footer-link-${n.label.toLowerCase()}`}
                  className="font-sans text-cream/70 hover:text-gold transition-colors duration-300"
                >
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-3">
          <p className="eyebrow mb-5">Contact</p>
          <a
            href="mailto:info@prospecconsultancy.com"
            data-testid="footer-email"
            className="font-sans text-cream/70 hover:text-gold transition-colors duration-300 break-all"
          >
            info@prospecconsultancy.com
          </a>
          <a
            href="https://wa.me/447827229323"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp"
            className="block mt-3 font-sans text-cream/70 hover:text-gold transition-colors duration-300"
          >
            WhatsApp: +44 7827 229323
          </a>
          <p className="font-sans text-cream/40 text-sm mt-3">
            Response within one working day.
          </p>
        </div>
      </div>

      <div
        aria-hidden
        className="font-display font-bold text-cream/5 leading-none select-none tracking-tighter"
        style={{ fontSize: "clamp(4rem, 18vw, 20rem)" }}
      >
        PROSPEC
      </div>

      <div className="mt-8 pt-6 border-t border-cream/10 flex flex-col md:flex-row justify-between gap-3">
        <p className="font-mono text-xs text-cream/40 tracking-wide">
          © {new Date().getFullYear()} PROSPEC Consultancy. All rights reserved.
        </p>
        <p className="font-mono text-xs text-cream/40 tracking-wide">
          Project Planning · Resource Optimization · Strategic Execution & Control
        </p>
      </div>
    </div>
  </footer>
);
